// extracted by mini-css-extract-plugin
export default {"archive-tab-wrapper":"archive-tab_archive-tab-wrapper__0eWQs"};